import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['billingDetails', 'billingDetailsModal', 'shiftDaysContainer', 'shiftDaysSelect']

  toggleBillingDetailsSection() {
      this.billingDetailsTarget.classList.toggle('d-none');
  }

  toggleBillingDetailsSectionModal() {
      this.billingDetailsModalTarget.classList.toggle('d-none');
    }

  toggleShiftDays(event) {
    const select = event.target;
    if (select.value === "true") {
      this.shiftDaysContainerTarget.classList.remove('d-none');
    } else {
      this.shiftDaysContainerTarget.classList.add('d-none');
      this.resetShiftDaysValue();
    }
  }

  resetShiftDaysValue() {
    if (this.hasShiftDaysSelectTarget) {
      this.shiftDaysSelectTarget.value = 0;
    }
  }
}
